export const ACTION_DATE_FIELDS = Object.freeze({
  repair: { field: 'RepairWarrantyEndDate', hideExpired: false, blockExpiredEarmoulds: true },
  remake: { field: 'RemakeWarrantyEndDate', hideExpired: false, blockExpiredEarmoulds: true },
  return: { field: 'ReturnForCreditEndDate', hideExpired: true },
  lostAndDamage: { field: 'LostAndDamageWarrantyEndDate', hideExpired: true },
  registerWarranty: { field: 'RepairWarrantyEndDate', hideExpired: true },
  extendWarranty: { field: 'RepairWarrantyEndDate', hideExpired: true },
  replaceReceivers: { field: 'RepairWarrantyEndDate', hideExpired: true },
});
